import { SelectItem } from "primeng/api";

enum UserTitle {
    Mr = 1,
    Mrs,
    Miss,
    Ms,
    Dr,
    Other
}

const UserTitleMap: { [key: number]: string } = {};
UserTitleMap[UserTitle.Other] = "Other";
UserTitleMap[UserTitle.Mr] = "Mr";
UserTitleMap[UserTitle.Miss] = "Miss";
UserTitleMap[UserTitle.Mrs] = "Mrs";
UserTitleMap[UserTitle.Dr] = "Dr";

const createOptions = () => Object.keys(UserTitleMap).map(k => <SelectItem>{ value: +k, label: UserTitleMap[k] });

const getTitle = (title?: UserTitle) => (title in UserTitleMap ? UserTitleMap[title] : "");

export { UserTitle, UserTitleMap, createOptions, getTitle };
